import React, { useState, useRef, useEffect } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import { useAuth } from '../../contexts/AuthContext';
import NotificationBadge from './NotificationBadge';
import NotificationsPanel from './NotificationsPanel';
import '../../css/NotificationBell.css';

const NotificationBell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { notifications, unreadCount, fetchNotifications } = useNotifications();
  const { token } = useAuth();
  const bellRef = useRef();

  useEffect(() => {
    if (token) {
      console.log("NotificationBell: Fetching notifications");
      fetchNotifications();
    }
  }, [token, fetchNotifications]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Don't show the notification bell if not logged in
  if (!token) {
    return null;
  }

  return (
    <div className="notification-bell-container" ref={bellRef}>
      <button 
        className={`notification-bell ${isOpen ? 'active' : ''} ${unreadCount > 0 ? 'has-notifications' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className="fas fa-bell"></i>
        {unreadCount > 0 && <NotificationBadge count={unreadCount} />}
      </button>
      {isOpen && (
        <NotificationsPanel 
          onClose={() => setIsOpen(false)} 
        />
      )}
    </div>
  );
};

export default NotificationBell; 